import loadable from '@loadable/component';

export const GradFairsLinksLoadable = loadable(
  () => import('./GradFairsLinks'),
  { resolveComponent: (module) => module.GradFairsLinks },
);
